import { DialogContent, DialogTitle } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';

import { useInitiateBHAssessment } from '@hooks/api/assessment';

import type { AssessmentType } from 'generated/types';

const messages = defineMessages({
  title: {
    id: 'bhaQrCode.title',
    defaultMessage:
      'Use this QR Code to start the Digital Health Assessment (DHA)',
  },
});

interface QrCodeProps {
  vitall_patient_id: string;
  assessmentType: AssessmentType;
}

const QrCode: React.FC<QrCodeProps> = ({
  vitall_patient_id,
  assessmentType,
}) => {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState('');
  const [initiateBha, initiateBhaLoading] = useInitiateBHAssessment();

  useEffect(() => {
    async function fetchQrCode() {
      const { data } = await initiateBha({
        vitall_patient_id,
        type: assessmentType,
      });
      const qr_code = data?.initiateAssessment.token;
      if (qr_code) {
        setValue(qr_code);
      }
    }
    if (vitall_patient_id) {
      fetchQrCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vitall_patient_id]);

  return (
    <>
      <DialogTitle>
        {initiateBhaLoading ? '' : formatMessage(messages.title)}
      </DialogTitle>
      <DialogContent>
        <ContentLoader loading={initiateBhaLoading}>
          {value ? (
            <QRCodeSVG value={value} size={200} width="100%" height="100%" />
          ) : null}
        </ContentLoader>
      </DialogContent>
    </>
  );
};

export default QrCode;
